module.exports = __webpack_public_path__ + "img/newrow_logo.b96937fc.svg";